export const permissionGroups = [
    {
        name: "Marketing",
        subPermissions: ["Advertisement", "New Release", "Tutorials", "Practice Documents"],
    },
    {
        name: "Sales",
        subPermissions: ["Create Lead", "Read Lead", "Update Lead", "Delete Lead"],
    },
    {
        name: "Students",
        subPermissions: ["Create Student", "Read Student", "Update Student", "Delete Student"],
    },
    {
        name: "Instructors",
        subPermissions: ["Approve User", "Read Users", "Update User"],
    },
    {
        name: "TMS",
        subPermissions: ["TMS Users", "IFTA", "Policies"],
    },
    {
        name: "DOT Compliance",
        subPermissions: ["View", "Notes", "Activity", "Business Info"],
        isSubPermission: true,
    },
    {
        name: "Human Resources",
        subPermissions: ["View", "Notes", "Activity", "Add More","Delete"],
        isSubPermission: true,
    },
    {
        name: "Biz Partners",
        subPermissions: ["View", "Notes", "Activity", "Business Info"],
        isSubPermission: true,
    },
    {
        name: "Accounting",
        subPermissions: ["AP", "Invoicing", "Expenses", "Account Reports"],
    },
    {
        name: "Demo",
        subPermissions: ["Create", "Read", "Update", "Delete"],
    },
    {
        name: "Candidates",
        subPermissions: ["Create", "Read", "Update", "Delete"],
    },
    {
        name: "Recordings",
        subPermissions: ["Read", "Update", "Close"],
    },
    {
        name: "TMS Users",
        subPermissions: ["View", "Password Access","Delete"],
        isSubPermission: true,
    },
    {
        name: "Jobs",
        subPermissions: [],
        isSubPermission: false,
    },
    {
        name: "Courses",
        subPermissions: ["Section Delete","Content"],
        isSubPermission: true,
    },
];
